import { render, staticRenderFns } from "./BIApprovalFilter.vue?vue&type=template&id=d572ef94&"
import script from "./BIApprovalFilter.vue?vue&type=script&lang=js&"
export * from "./BIApprovalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports